import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { HomeScreen } from '@/features/home/routes/home-screen'
import { pageTitle } from '@/lib/brand'

export const Route = createFileRoute('/')({ component: Home })

function Home() {
  useEffect(() => {
    document.title = pageTitle('Today')
  }, [])

  return <HomeScreen />
}
